var map = {
	"./fun1.png": "d531",
	"./fun2.png": "18d2",
	"./fun3.png": "1978",
	"./fun4.png": "5000",
	"./fun5.png": "20ab",
	"./fun6.png": "8010",
	"./fun7.png": "5075",
	"./fun8.png": "f60d",
	"./fun9.png": "0ed2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "399e";